import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Main from './views/Main.vue'
import Student from './views/Dossier/Student.vue'
import Groups from './views/Dossier/Groups.vue'
import Group_Students from './views/Group_Students.vue'
import Schedule from './views/Dossier/Schedule.vue'
import Transmission from './views/Dossier/Transmission.vue'
import Bulletin from './views/Dossier/Bulletin.vue'
import Paiements from './views/Dossier/Paiements.vue'
import Paiements_II from './views/Dossier/Paiements_II.vue'
import StudentMain from './views/Student/Main.vue'
import StudentNotes from './views/Student/Courses.vue'
import Admin from './views/Admin/Admin.vue'

import ProfMain from './views/Prof/Main.vue'

// DIRECT
import Compensation_MES from './views/DIRECT/Compensation_MES.vue'


Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkExactActiveClass: 'is-active',
  routes: [
/*     {
      path: '/',
      name: '/',
      component: Bulletin
    }, */

    {
      path: '/compensation_mes/:ecole', /// IF THEY CLICK THE LINK - IN!
      name: 'compensation_mes',
      component: Compensation_MES
    },



    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/main',
      name: 'main',
      component: Main,
      meta: { requiresAuth: true }
    },

    {
      path: '/student',
      name: 'student',
      component: Student,
      meta: { requiresAuth: true }
    },
    {
      path: '/groups',
      name: 'groups',
      component: Groups,
      meta: { requiresAuth: true }
    },
    {
      path: '/paiements',
      name: 'paiements',
      component: Paiements,
      meta: { requiresAuth: true }
    },
    {
      path: '/paiements_II',
      name: 'paiements_II',
      component: Paiements_II,
      meta: { requiresAuth: true }
    },
    {
      path: '/groupstudent',
      name: 'groupstudent',
      component: Group_Students,
      meta: { requiresAuth: true }
    },
    {
      path: '/schedule',
      name: 'schedule',
      component: Schedule,
      meta: { requiresAuth: true }
    },
    {
      path: '/transmission',
      name: 'transmission',
      component: Transmission,
      meta: { requiresAuth: true }
    },
    {
      path: '/bulletin',
      name: 'bulletin',
      component: Bulletin,
      meta: { requiresAuth: true }
    },
    {
      path: '/student/main',
      name: 'student_main',
      component: StudentMain,
      meta: { requiresAuth: true }
    },
    {
      path: '/student/notes',
      name: 'student_notes',
      component: StudentNotes,
      meta: { requiresAuth: true }
    },
    {
      path: '/prof/main',
      name: 'prof_main',
      component: ProfMain,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/admin',
      name: 'admin',
      component: Admin,
      meta: { requiresAuth: true }
    },
  ]
})


router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (sessionStorage.getItem('isGood') === null) {
      next('login')
    } else { next() }
  } else {
      next()     
  }
});


export default router

